export enum MaritalStatuses {
  Married = 'married',
  Widowed = 'widowed',
  Separated = 'separated',
  Divorced = 'divorced',
  Single = 'single',
}
